import { ref } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'
import store from '@/store'
import axios from '@axios'

const getFilterOptionsBy=function(q) {
     
    return new Promise((resolve, reject) => {
      axios.get('filters/getFilterBy', { params: q})
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }
export default function TotalAbsencePerMonthFormOptions() {

    const contractsOptions = ref([])
    const contractsOptions_orig=ref([])
    const ownersOptions=ref([])

  
    getFilterOptionsBy({type:'device'})
  
    .then(response => {
     
      const { 
       contracts, owners, } = response.data.data
        ownersOptions.value = owners
      contractsOptions.value = contracts
      contractsOptions_orig.value=contracts
    
    




    })

    return {

        contractsOptions,
        ownersOptions,
        contractsOptions_orig
    }
}